/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fireCmdbErrorAnalytics } from '@jira/servicedesk__insight-common-utils-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { performCmdbGetRequest } from '@jira/servicedesk__insight-common-utils-cmdb-client/src/performCmdbGetRequest.tsx';
import { getDataManagerFetchContainerTokenUrl } from '@jira/servicedesk__insight-common-utils-cmdb-rest-urls/src/getDataManagerProvisioningStatusUrl.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { ActionApi, FetchTokensResponse } from './ActionApi.types.tsx';

export const fetchDataManagerTokens =
	(): ActionApi =>
	async ({ setState, getState }, { workspaceId, createAnalyticsEvent }) => {
		const state = getState();

		if (state.dataManager.tokensLoading) {
			return;
		}
		setState({
			...state,
			dataManager: { ...state.dataManager, tokensLoading: true },
		});

		try {
			const tokenDetails: FetchTokensResponse = await performCmdbGetRequest(
				getDataManagerFetchContainerTokenUrl(workspaceId),
			);

			setState(
				fg('aurum_dm_settings_stale_state_fix')
					? {
							...getState(),
							dataManager: {
								...getState().dataManager,
								tokensData: tokenDetails.tokens,
								tokensLoading: false,
							},
						}
					: {
							dataManager: {
								...state.dataManager,
								tokensData: tokenDetails.tokens,
								tokensLoading: false,
							},
						},
			);
			fireTrackAnalytics(createAnalyticsEvent({}), 'fetchDataManagerTokens succeeded');
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState(
				fg('aurum_dm_settings_stale_state_fix')
					? {
							...getState(),
							dataManager: {
								...getState().dataManager,
								tokensLoading: false,
								tokensError: error,
							},
						}
					: {
							...state,
							dataManager: { ...state.dataManager, tokensLoading: false, tokensError: error },
						},
			);
			fireCmdbErrorAnalytics({
				meta: {
					id: 'fetchDataManagerTokens',
					packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
				},
				error,
			});

			throw error;
		}
	};
